import React, { Component } from "react";
import ReactFlagsSelect from "react-flags-select";
import utils from "../../services/utils";
import Language from "../../services/Language";



class InputCountry extends Component {
  state = {
    country: 'RU',
    baseCountry: null,
    all: {},
    codes: {},
    availableCountries: []
  }

  setFieldValue(value) {
    let country = this.state.codes[value].id
    utils.app_post(utils.getLocalizeUrl('/api/account/set-base-country'), { baseCountry: country }).then((resp) => {
      if (resp.type === 'success') {
        this.setState({ country: value })
      }
    });
  }

  componentDidMount() {
    const resp = this.props.countriesData;
    if (resp && resp.type === 'success') {

      let countries = {}
      let countriesCodes = {}

      resp.data.countries.forEach((item) => {
        countries[item.id] = item
        countriesCodes[item.code] = { ...item, primary: item.name }
      })

      let availableCountries = Object.keys(countriesCodes)
        .sort(function (a, b) {
          return countriesCodes[a].order - countriesCodes[b].order
        }
        );

      this.setState({
        country: countries[resp.data.baseCountry].code,
        baseCountry: resp.data.baseCountry,
        all: countries,
        codes: countriesCodes,
        availableCountries: availableCountries
      })
    }
  }

  render() {
    const { country, baseCountry } = this.state;
    const { inputName } = this.props

    return (
      <div>
        <ReactFlagsSelect
          searchable
          fullWidth={true}
          showSelectedLabel={false}
          showOptionLabel={true}
          selected={country || baseCountry}
          customLabels={this.state.codes}
          countries={this.state.availableCountries}
          onSelect={(value) => this.setFieldValue(value)}
          className={"country-select"}
          searchPlaceholder=" "
        />
        <input type="hidden" name={inputName || 'country-input'} value={country} />
      </div>
    )
  }
}

export default InputCountry